var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"p-background-primary rounded-0",attrs:{"width":"100%","height":"6","elevation":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }